export const kMapTileType = "Map"
export const kV2MapType = "map"
export const kMapTileClass = "codap-map"
export const kMapModelName = "MapModel"

export const kMapIdPrefix = "MAP_"
